import { MessageCircle } from 'lucide-react';
import { getWhatsAppLink } from '../lib/utils';

export const WhatsAppFAB = () => {
  return (
    <a
      href={getWhatsAppLink("Bonjour, je suis intéressé par vos services JoSmart.")}
      target="_blank"
      rel="noopener noreferrer"
      className="fab-whatsapp"
      data-testid="whatsapp-fab"
      aria-label="Contactez-nous sur WhatsApp"
    >
      <MessageCircle size={28} className="text-white" />
    </a>
  );
};

export default WhatsAppFAB;
